import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  updateUserBio,
  getAthleteProfile,
} from "../../../services/AthleteService";
import { useAxiosInstance } from "../../../services/Interceptor";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

const UpdateBio = () => {
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();
  const [isUpdatingBio, setIsUpdatingBio] = useState(false);
  const { register, handleSubmit, setValue } = useForm();
  const [bio, setBio] = useState("");

  useEffect(() => {
    const fetchBio = async () => {
      try {
        const response = await getAthleteProfile(
          apiInstance,
          authUser?.user?.id,
        );
        if (response) {
          setValue("bio", response.bio);
          setBio(response.bio);
        }
      } catch (error) {
        console.log("Error fetching bio:", error);
      }
    };

    fetchBio();
  }, [apiInstance, authUser?.user?.id, setValue]);

  const handleUpdateBio = async (data) => {
    if (!data.bio.trim()) {
      toast.warning("Bio cannot be empty.", { position: "top-right" });
      return;
    }

    if (data.bio.length > 500) {
      toast.warning("Bio cannot exceed 500 characters.", {
        position: "top-right",
      });
      return;
    }

    try {
      setIsUpdatingBio(true);
      await updateUserBio(apiInstance, authUser?.user?.id, data.bio);
      toast.success("Bio updated successfully!", { position: "top-right" });
      setBio(data.bio);
    } catch (error) {
      toast.error("Error updating bio: " + error.message, {
        position: "top-right",
      });
    } finally {
      setIsUpdatingBio(false);
    }
  };

  return (
    <form className="w-full mt-4" onSubmit={handleSubmit(handleUpdateBio)}>
      <div className="bg-white shadow-lg p-4 rounded-lg">
        <h1 className="text-xl mb-6 uppercase">UPDATE BIO</h1>
        <textarea
          className="w-full p-2 border border-gray-300 rounded-md"
          placeholder="Write your bio here..."
          {...register("bio", { required: true })}
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          style={{
            maxHeight: "400px",
            overflow: "auto",
            resize: "vertical",
          }}
        />
        <div className="text-right text-sm text-gray-500 mt-1">
          {bio && bio.length}/500 characters
        </div>
        <div className="flex justify-end mt-0">
          <button
            type="submit"
            className={`mt-2 px-4 py-2 rounded-md ${
              isUpdatingBio ? "bg-gray-400" : "bg-red-500 hover:bg-red-800"
            } text-white`}
            disabled={isUpdatingBio}
          >
            {isUpdatingBio ? "Updating..." : "UPDATE BIO"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default UpdateBio;
